import { render, staticRenderFns } from "./activity3-1.vue?vue&type=template&id=1ea56a59&scoped=true"
import script from "./activity3-1.vue?vue&type=script&lang=js"
export * from "./activity3-1.vue?vue&type=script&lang=js"
import style0 from "./activity3-1.vue?vue&type=style&index=0&id=1ea56a59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea56a59",
  null
  
)

export default component.exports